export default __webpack_public_path__ + "static/media/digital-store.8566999b.png";